<template>
  <div>
    <sc-form
      @change="updateFields"
      :form="quoteFreightProduct"
      :rules="rulesProducts"
      @submit="submit">

      <template
        slot="fields"
        slot-scope=" { fields }">
        <sc-real-time-quotation/>
        <sc-logistic-draft/>
        <sc-basic-data :fields="fields"/>
        <hr />
        <sc-product :fields="fields"/>
      </template>
      <template slot="actions" slot-scope="{ isValid }">
        <sc-button
          @click="backUrl"
          theme="default"
          text="Voltar"/>
        <sc-button
          type="submit"
          theme="primary"
          text="Calcular"/>
      </template>
    </sc-form>
    <sc-delivery-options :fields="newFields"/>
    <sc-excluded-methods/>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScForm,
  ScInput,
  ScField,
  ScButton,
} from '@intelipost-js/secure-components';
import ScBasicData from '../sc-basic-data/ScBasicData';
import ScDeliveryOptions from '../sc-delivery-options/ScDeliveryOptions';
import ScExcludedMethods from '../sc-excluded-methods/ScExcludedMethods';
import ScProduct from '../sc-product/ScProduct';
import ScRealTimeQuotation from '../sc-real-time-quotation/ScRealTimeQuotation.vue';
import ScLogisticDraft from '../sc-logistic-draft/ScLogisticDraft';

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('quote/freightQuote');

export default {
  name: 'sc-quote-freight-by-product',
  data() {
    return {
      newFields: {},
    };
  },
  computed: {
    ...mapState([
      'quoteFreightProduct',
      'logistic_contract_mode',
      'shipment_type',

    ]),
    rulesProducts() {
      const {
        newFields,
        quoteFreightProduct,
      } = this;

      const {
        products,
      } = newFields;

      const {
        products: productsState,
      } = quoteFreightProduct;

      const newProducts = products || productsState;

      const newRules = newProducts.map((product, productKey) => ({
        [productKey]: {
          type: 'object',
          required: true,
          fields: {
            length: [{
              required: true,
              message: 'Preencha o comprimento',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (!value || value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
            weight: [{
              required: true,
              message: 'Preencha o peso',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (!value || value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
            quantity: [{
              required: true,
              min: 1,
              message: 'Preencha a quantidade',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (!value || value <= 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
            description: [{
              required: true,
              message: 'Preencha a descriçāo',
            }],
            sku_id: [{
              required: true,
              message: 'Preencha o sku',
            }],
            height: [{
              required: true,
              message: 'Preencha a altura',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (!value || value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
            width: [{
              required: true,
              message: 'Preencha a largura',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (!value || value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
            cost_of_goods: [{
              min: 0,
              message: 'Preencha o valor da nota fiscal',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
          },
        },
      })).reduce((itemA, itemB) => ({
        ...itemA,
        ...itemB,
      }), {});

      return {
        origin_zip_code: [
          {
            type: 'string',
            required: true,
            trigger: 'input',
            message: 'Informe o CEP completo no formato 00000-000',
            validator: (rule, value, callback, fields) => {
              const errors = [];
              if (fields.origin_zip_code.replace('-', '').length > 8) {
                errors.push(new Error(rule.message, rule.field));
                callback(errors);
              }

              callback(errors);
            },
          },
        ],
        additional_business_days: [
          {
            message: 'Preencha uma quantidade de dias',
            trigger: 'input',
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error(rule.message));
              }
              callback();
            },
          },
        ],
        destination_zip_code: [
          {
            type: 'string',
            required: true,
            trigger: 'input',
            message: 'Informe o CEP completo no formato 00000-000',
            validator: (rule, value, callback, fields) => {
              const errors = [];

              if (fields.destination_zip_code.length < 9) {
                errors.push(new Error(rule.message, rule.field));
                callback(errors);
              }

              callback(errors);
            },
          },
        ],
        products: [{
          type: 'array',
          fields: newRules,
        }],
      };
    },
  },
  methods: {
    ...mapActions([
      'quoteByProduct',
    ]),
    backUrl() {
      window.history.back();
    },
    updateFields(event) {
      this.newFields = event;
    },
    submit(config) {
      const {
        products,
        origin_zip_code,
        destination_zip_code,
        additional_information,
      } = config;

      const configTransformed = Object.assign({}, {
        products: products
          .map((product) => {
            const {
              weight,
              height,
              cost_of_goods,
              length,
              width,
              can_group,
              description,
              quantity,
              sku_id,
            } = product;

            return {
              weight,
              height,
              cost_of_goods: cost_of_goods === '' ? 0 : cost_of_goods,
              length,
              width,
              can_group,
              description,
              quantity,
              sku_id,
            };
          }),
        origin_zip_code,
        destination_zip_code,
        additional_information,
        logistic_contract_mode: this.logistic_contract_mode,
        shipment_type: this.shipment_type,
      });
      return this.quoteByProduct(configTransformed);
    },
  },
  beforeMount() {
    const {
      $route,
    } = this;

    const {
      params,
    } = $route;

    const {
      quoteFreightVolume,
    } = params;

    const {
      origin_zip_code,
    } = quoteFreightVolume || {};

    if (quoteFreightVolume) {
      return this.$store.commit('quote/freightQuote/setquoteFreightProduct', {
        ...this.quoteFreightProduct,
        origin_zip_code,
      });
    } return quoteFreightVolume;
  },
  components: {
    ScForm,
    ScInput,
    ScField,
    ScBasicData,
    ScProduct,
    ScButton,
    ScDeliveryOptions,
    ScExcludedMethods,
    ScLogisticDraft,
    ScRealTimeQuotation,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-quote-freight-by-product/ScQuoteFreightByProduct.vue?69bfc91a